export default "__VITE_ASSET__U9WM1ea6__"